export default __webpack_public_path__ + "0cb0212c742da929bcfe8d8e24140f43.jpg";